




































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import { CompanyDocument } from '../store/models';
import * as api from '@/store/api';

@Component
export default class MetaValuation extends CompanyMixin {
    @Prop() readonly doc!: CompanyDocument;

    valuationM: any = {};

    @Watch('doc', { immediate: true, deep: true })
    async onDocChanged() {
        // tslint:disable-next-line:max-line-length
        this.valuationM = await api.getValuation(this.doc.Data.CAPM_OFFSET, this.doc.Data.AggVersion, this.doc.Data.OrgNr);
    }

    get valuation() {
        return this.valuationM;
    }

    get range() {
        const years = this.valuation.YEAR;
        const len = years.length;
        if (len === 0) { return ''; }
        if (len === 1) { return `Bokslutet från ${years[0]}`; }
        return `Bokslut från ${years[len - 1]} till ${years[0]}`;
    }
}
